<template>
  <v-row>
    <v-col 
      cols="12"
      v-if="  !loading &&
              user.roles.find(role => role === 'entrepreneur') &&
              edition.edition.waiting_room &&
              convocation_form.convocation_form.length!==0"
      >
      <entrepreneurInProgress 
        v-if="  convocation_form.convocation_form.condition=='in_progress' ||
                convocation_form.convocation_form.condition=='empty'">
      </entrepreneurInProgress>

      <entrepreneurPending 
        v-if="convocation_form.convocation_form.condition=='pending'">
      </entrepreneurPending>

      <entrepreneurAccepted 
        v-if="convocation_form.convocation_form.condition=='accepted'">
      </entrepreneurAccepted>

      <entrepreneurRejected 
        v-if="convocation_form.convocation_form.condition=='rejected'">
      </entrepreneurRejected>

    </v-col>

    <v-col 
      v-if="edition.edition.waiting_room">
      <homeWaitingRoom
        v-if="user.roles.find(role => role === 'participant')">
      </homeWaitingRoom>

      <homeWaitingRoomEntrepreneur
        v-if="user.roles.find(role => role === 'entrepreneur')&&convocation_form.convocation_form.length===0">
      </homeWaitingRoomEntrepreneur>
    </v-col>

    <v-col cols="12" v-if="!loading && !edition.edition.waiting_room">
      <homeOne 
        v-if="edition.edition.edition_customization.home_selected==1" />
      <homeTwo 
        v-if="edition.edition.edition_customization.home_selected==2" />
      <homeThree
        v-if="edition.edition.edition_customization.home_selected==3" />
      <homeFour
        v-if="edition.edition.edition_customization.home_selected==4" />

    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  const APP_URL = process.env.VUE_APP_URL
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  import entrepreneurInProgress from '@/components/entrepreneur/home/entrepreneurInProgress.vue'
  import entrepreneurPending from '@/components/entrepreneur/home/entrepreneurPending.vue'
  import entrepreneurAccepted from '@/components/entrepreneur/home/entrepreneurAccepted.vue'
  import entrepreneurRejected from '@/components/entrepreneur/home/entrepreneurRejected.vue'

  import homeOne from '@/components/entrepreneur/home/homeOne.vue'
  import homeTwo from '@/components/entrepreneur/home/homeTwo.vue'
  import homeThree from '@/components/entrepreneur/home/homeThree.vue'
  import homeFour from '@/components/entrepreneur/home/homeFour.vue'

  import homeWaitingRoom from '@/components/participant/home/homeWaitingRoom.vue'
  import homeWaitingRoomEntrepreneur from '@/components/entrepreneur/home/homeWaitingRoomEntrepreneur.vue'

  export default {
    name: 'Home',
    components: {
      entrepreneurInProgress,
      entrepreneurPending,
      entrepreneurAccepted,
      entrepreneurRejected,

      homeOne,
      homeTwo,
      homeThree,
      homeFour,

      homeWaitingRoom,
      homeWaitingRoomEntrepreneur
    },
    data: () => ({
      loading: false,
      dialog_edition:false,
      state_convocation_form: 'in_progress',
      types_sponsors:[],
      access_enabled:true,
      condition_entrepreneur: 'empty',
      info_edition:[],
      user_rol: null,
      home_image: null,
      home_logo: null
    }),

    computed: {
      ...mapGetters([
        'isLogged', 'drawer', 'user', 'convocation_form', 'edition', 'edition_id'
      ])
    },

    watch: {
      edition: {
        handler(newValue) {
          this.home_image = APP_URL + newValue.edition.edition_customization.home_image
          this.home_logo = APP_URL + newValue.edition.edition_customization.home_logo
        },
        deep: true
      },
    },

    methods:{
      async checkRoles(){
        const userRoles = this.user.roles;
        let redirectRoute = '';

        switch (true) {
          case userRoles.includes('entrepreneur'):
            this.user_rol = 'entrepreneur'
            this.getStatus()
            break;
          case userRoles.includes('participant'):
            this.user_rol = 'participant'
            this.loading = false
            break;
          case userRoles.includes('admin'):
            this.user_rol = 'admin'
            break;
          case userRoles.includes('evaluator'):
            this.user_rol = 'evaluator'
            break;
          case userRoles.includes('tutor'):
            this.user_rol = 'tutor'
            break;
          case userRoles.includes('organizer'):
            this.user_rol = 'organizer'
            break;
        }

        if (redirectRoute) {
          this.$store.dispatch('Logged', { is_logged: true });
          this.loading = false;
          this.$router.push({ name: redirectRoute });
        }
      },

      //----------------------------------------------------------------------------------
      //----------------------------------------------------------------------------------
      //----------------------------------------------------------------------------------

      async getStatus(){
        this.loading = true
        await axios.get('convocation/status/'+this.convocation_form.convocation_form.id).then((response) =>{
          this.state_convocation_form=response.data.status
          this.loading = false
          // this.getInfoAccess()
        }).catch(error => {
          console.log(error);
        })
      }
    },
    created(){
      this.checkRoles()
    },
  }
</script>
<style scoped>
.link-item {
  display: block;
  margin-bottom: 10px; /* Adjust as needed */
}

.contenedor-imagenes img {
  display: block; /* Asegura que las imágenes se muestren como bloques */
  margin-bottom: 10px; /* Espacio entre las imágenes (puedes ajustar el valor según tus preferencias) */
}

.image-overlay{
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

</style>